import { proxy } from '@/utils'

import { core } from '@/components/services/settingsSite/utils'

import render from './render'

export default function(options) {
  return {
    mixins: [ proxy({ type: 'object' }), core(options) ],

    render(h) {
      return render.call(this, h, options)
    }
  }
}
